import React, {useContext} from "react";
import "./Carousel.css";
import CarouselMobile from "./CarouselMobile";
import CarouselDesktop from "./CarouselDesktop";
import {AppContext} from "../../App";

function Carousel({images, details}) {
    const {isMobile} = useContext(AppContext);

    if (isMobile){
        return(
            <CarouselMobile images={images} details={details} />
        );
    }

    return (
        <CarouselDesktop images={images} details={details} />
    );
}

export default Carousel;
